/**
 * Horlogerieshop.nl — Sticky Add to Cart
 * assets/sticky-atc.js  |  defer — alleen op productpagina's
 */

(function () {
  'use strict';

  const MAIN_FORM_SELECTOR = 'form[action="/cart/add"]';
  const MAIN_BTN_SELECTOR  = `${MAIN_FORM_SELECTOR} [name="add"], ${MAIN_FORM_SELECTOR} button[type="submit"]`;
  const MAIN_VAR_SELECTOR  = `${MAIN_FORM_SELECTOR} [name="id"]`;

  let bar, btn, priceEl, compareEl, variantLabelEl;

  function init() {
    /* DOM-level guard: werkt over meerdere script-instanties heen */
    if (document.body.hasAttribute('data-satc-init')) return;
    document.body.setAttribute('data-satc-init', '');

    bar            = document.getElementById('sticky-atc');
    btn            = document.getElementById('satc-btn');
    priceEl        = document.getElementById('satc-price');
    compareEl      = document.getElementById('satc-compare');
    variantLabelEl = document.getElementById('satc-variant-label');

    if (!bar || !btn) return;

    setupObserver();
    setupCartHandler();
    setupVariantSync();
  }

  /* ── IntersectionObserver ───────────────────────────────────────────── */
  function setupObserver() {
    const mainBtn = document.querySelector(MAIN_BTN_SELECTOR);
    if (!mainBtn) { show(); return; }

    new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting) {
          /* Knop zichtbaar — sticky altijd verbergen */
          hide();
        } else {
          /* Knop buiten beeld — alleen tonen als knop BOVEN viewport is
             (gebruiker heeft er voorbij gescrolld), niet als hij er nog
             naartoe moet scrollen (knop is nog onder de viewport)        */
          if (entry.boundingClientRect.top < 0) {
            show();
          } else {
            hide();
          }
        }
      },
      { threshold: 0, rootMargin: '0px' }
    ).observe(mainBtn);
  }

  function show() { bar.classList.add('is-visible'); bar.setAttribute('aria-hidden', 'false'); }
  function hide() { bar.classList.remove('is-visible'); bar.setAttribute('aria-hidden', 'true'); }

  /* ── Add to cart ────────────────────────────────────────────────────── */
  function setupCartHandler() {
    btn.addEventListener('click', addToCart);
  }

  async function addToCart() {
    /* DOM-level guard: data-attribuut is zichtbaar voor alle script-instanties */
    if (btn.hasAttribute('data-adding')) return;
    btn.setAttribute('data-adding', '');

    const id = getVariantId();
    if (!id) { btn.removeAttribute('data-adding'); return; }

    setState('loading');

    try {
      const res = await fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ id, quantity: 1 }),
      });

      if (!res.ok) throw new Error(`Cart error ${res.status}`);

      setState('success');
      await openCartDrawer();
      setTimeout(() => setState('idle'), 2400);

    } catch (err) {
      console.warn('[Sticky ATC]', err.message);
      setState('idle');
    } finally {
      btn.removeAttribute('data-adding');
    }
  }

  /* ── Cart drawer ─────────────────────────────────────────────────────
   *  Dawn werkt via Shopify's sections API:
   *  1. Haal bijgewerkte HTML op voor cart-drawer + icon bubble
   *  2. Vervang de sectie-HTML in de DOM
   *  3. Herquery cart-drawer (DOM is vernieuwd) en roep .open() aan
   * ──────────────────────────────────────────────────────────────────── */
  async function openCartDrawer() {
    try {
      /* cache: 'no-store' + timestamp voorkomt een gecachede lege cart */
      const url      = `/cart?sections=cart-drawer,cart-icon-bubble&_=${Date.now()}`;
      const res      = await fetch(url, { cache: 'no-store' });
      const sections = await res.json();

      /* Werk de inhoud van <cart-drawer> bij — NIET de #shopify-section wrapper.
         Dawn's eigen renderContents() werkt ook zo: het custom element zelf
         blijft in de DOM staan zodat connectedCallback niet opnieuw vuurt
         en de lege-cart state niet overschreven wordt.                       */
      if (sections['cart-drawer']) {
        const parsed      = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        const newDrawerEl = parsed.querySelector('cart-drawer');
        const oldDrawerEl = document.querySelector('cart-drawer');

        if (oldDrawerEl && newDrawerEl) {
          oldDrawerEl.innerHTML = newDrawerEl.innerHTML;

          /* Sync de class — verwijdert 'is-empty' zodra de cart items heeft.
             Dawn's CSS verbergt cart-inhoud zolang is-empty op het element staat,
             ook al heeft de innerHTML al de juiste producten.                    */
          oldDrawerEl.className = newDrawerEl.className;
        }

        /* cart-drawer-items heeft ook een eigen is-empty class */
        const newItemsEl = parsed.querySelector('cart-drawer-items');
        const oldItemsEl = document.querySelector('cart-drawer-items');
        if (oldItemsEl && newItemsEl) {
          oldItemsEl.className = newItemsEl.className;
        }
      }

      /* Cart icon bubble (aantal) bijwerken */
      if (sections['cart-icon-bubble']) {
        const parsed = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        document.querySelectorAll('.cart-count-bubble').forEach(el => {
          const newEl = parsed.querySelector('.cart-count-bubble');
          if (newEl) el.innerHTML = newEl.innerHTML;
        });
      }

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      }

    } catch (err) {
      console.warn('[Sticky ATC] Cart drawer:', err.message);
      window.location.href = '/cart';
    }
  }

  function setState(state) {
    btn.classList.remove('is-loading', 'is-success');
    btn.disabled = false;
    const label = btn.querySelector('.satc-label');

    if (state === 'loading') {
      btn.classList.add('is-loading');
      btn.disabled = true;
    } else if (state === 'success') {
      btn.classList.add('is-success');
      if (label) label.textContent = '✓ Toegevoegd';
    } else {
      if (label) {
        label.textContent = btn.disabled
          ? (window.Shopify?.i18n?.sold_out    ?? 'Uitverkocht')
          : (window.Shopify?.i18n?.add_to_cart ?? 'In winkelwagen');
      }
    }
  }

  /* ── Variant sync ───────────────────────────────────────────────────── */
  function setupVariantSync() {
    document.addEventListener('variant:changed', onVariantChanged);
    document.addEventListener('variantChange',   onVariantChanged);

    const mainSel = document.querySelector(MAIN_VAR_SELECTOR);
    if (mainSel) mainSel.addEventListener('change', () => fetchVariantById(parseInt(mainSel.value, 10)));
  }

  function onVariantChanged(e) {
    const variant = e.detail?.variant ?? e.detail;
    if (!variant) return;

    if (variantLabelEl && variant.title !== 'Default Title') {
      variantLabelEl.textContent = variant.title;
    }

    if (priceEl) priceEl.textContent = formatMoney(variant.price);

    if (compareEl) {
      if (variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }

    btn.disabled = !variant.available;
    const label = btn.querySelector('.satc-label');
    if (label) {
      label.textContent = variant.available
        ? (window.Shopify?.i18n?.add_to_cart ?? 'In winkelwagen')
        : (window.Shopify?.i18n?.sold_out    ?? 'Uitverkocht');
    }
  }

  function fetchVariantById(variantId) {
    const handle = document.querySelector('[data-product-handle]')?.dataset.productHandle
      ?? window.location.pathname.split('/products/')[1]?.split('?')[0];
    if (!handle) return;

    fetch(`/products/${handle}.js`)
      .then(r => r.json())
      .then(p => {
        const v = p.variants.find(v => v.id === variantId);
        if (v) onVariantChanged({ detail: { variant: v } });
      })
      .catch(() => {});
  }

  /* ── Helpers ────────────────────────────────────────────────────────── */
  function getVariantId() {
    const mainSel = document.querySelector(MAIN_VAR_SELECTOR);
    if (mainSel) return parseInt(mainSel.value, 10);
    const hidden  = document.querySelector('input[name="id"]');
    return hidden ? parseInt(hidden.value, 10) : null;
  }

  function formatMoney(cents) {
    if (window.Shopify?.formatMoney) return Shopify.formatMoney(cents);
    return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  }

  /* ── Start ──────────────────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
